import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { AvatarProps } from "./avatar.types";

const Avatar = ({
  variant = "blue",
  size = "small",
  light = false,
  type = "avatar-pill",
  pill = "bottom-left",
  icon,
  iconProps,
  color,
  width,
  height,
  overflow
}: AvatarProps) => {
  return (
    <div
      role="presentation"
      className={`${type}--${pill} ${variant} ${size} ${light ? "light" : ""}`}
      style={{
        backgroundColor: color,
        width,
        height,
        overflow,
        minHeight: height
      }}
    >
      {icon && (
        <FontAwesomeIcon data-testid="icon" icon={icon} {...iconProps} />
      )}
    </div>
  );
};

export default Avatar;
